<template>
  <div class="base-numbered-header">
    <h4>{{ title }}</h4>
    <span v-if="number">{{ number }}</span>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseNumberedHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    number: {
      type: Number,
    },
  },
});
</script>
<style scoped lang="scss">
.base-numbered-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  h4,
  span {
    @extend %font-h2;
  }
  h4 {
    margin: 0;
    @include themed() {
      color: t($primary);
    }
  }
  span {
    font-weight: 300;
    @include themed() {
      color: t($grey-40);
    }
  }
}
</style>
